import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';
import {DeviceFilter} from '../../../features/devices/state/device.state';
import {DeviceListResponseDto, DeviceResponseDto, DeviceUpdateRequest} from '../../../features/devices/models/device-response.interface';

export interface DeviceStateService {

  getDevices(options: DeviceFilter): Observable<DeviceListResponseDto>;

  triggerDeviceAction(options: { id: string, value: boolean }): Observable<DeviceResponseDto>;

  getDeviceById(options: { id: string }): Observable<DeviceResponseDto>;

  updateDevice(options: DeviceUpdateRequest): Observable<DeviceResponseDto>;

  getConnectedValves(options: { pumpId: string }): Observable<DeviceListResponseDto>;

  replaceConnectedValves(options: { pumpId: string, connectedValveIds: string[] }): Observable<DeviceListResponseDto>;
}

export const DEVICE_STATE_SERVICE_INJECTION_TOKEN = new InjectionToken<DeviceStateService>('DeviceStateService');
